import { Middleware } from "@nuxt/types"
import { isSitecoreRequest } from "~/utils/isSitecoreRequest"

const isAuthorized: Middleware = ({ app, store, route, req }) => {
  if (isSitecoreRequest(req)) {
    return
  }

  if (!store.getters.currentUser) {
    return app.$login(route.path)
  }
}

export default isAuthorized
